/**
 * Códigos de PERMISO (RBAC · Ruta B) · espejo del catálogo del backend
 * (`Multiva.Shared.Application.Authorization.Permisos`). Se usan para el gateo
 * de UI: `<PermissionGate>` y los items del nav. Deben mantenerse en sincronía
 * con el backend (son las mismas cadenas estables `grupo.accion`).
 *
 * El backend es la frontera de seguridad real; esto solo decide qué se MUESTRA.
 */
export const PERMISOS = {
  // Solicitudes
  solicitudesGestionar: "solicitudes.gestionar",
  facturasVer: "facturas.ver",
  catalogosSolicitar: "catalogos.solicitar",
  notificacionesVer: "notificaciones.ver",
  contrapagosGestionar: "contrapagos.gestionar",
  // Autorización
  autorizacionAutorizar: "autorizacion.autorizar",
  autorizacionRechazar: "autorizacion.rechazar",
  autorizacionDarDeBaja: "autorizacion.dar_de_baja",
  calendarioPagosVer: "calendario_pagos.ver",
  // Consulta
  solicitudesVerTodas: "solicitudes.ver_todas",
  historicoDocumentalVer: "historico_documental.ver",
  auditoriaVer: "auditoria.ver",
  // Administración
  adminOrganizaciones: "admin.organizaciones",
  adminUsuarios: "admin.usuarios",
  adminRoles: "admin.roles",
  adminPermisos: "admin.permisos",
  adminAreas: "admin.areas",
  adminFlujosAutorizacion: "admin.flujos_autorizacion",
  adminProveedores: "admin.proveedores",
  adminCatalogosContables: "admin.catalogos_contables",
  adminCatalogosSat: "admin.catalogos_sat",
  adminEquivalenciasUnidad: "admin.equivalencias_unidad",
  adminIndicadoresImpuesto: "admin.indicadores_impuesto",
  adminMapeosClaveCuenta: "admin.mapeos_clave_cuenta",
  adminTiposDocumento: "admin.tipos_documento",
  adminCategoriasDocumento: "admin.categorias_documento",
  adminConfiguraciones: "admin.configuraciones",
  adminComprasSap: "admin.compras_sap",
  adminSatMock: "admin.sat_mock",
  adminSolicitudesCatalogo: "admin.solicitudes_catalogo",
  adminPlazo: "admin.plazo",
  // Reportería
  reporteriaUsar: "reporteria.usar",
  reporteriaAdministrar: "reporteria.administrar",
} as const;

/** Ver una solicitud (propia o todas) · para pantallas compartidas. */
export const VER_SOLICITUDES = [PERMISOS.solicitudesGestionar, PERMISOS.solicitudesVerTodas];

/** Todos los permisos de Administración + auditoría · para el hub `/admin`. */
export const PERMISOS_ADMIN = [
  PERMISOS.adminOrganizaciones, PERMISOS.adminUsuarios, PERMISOS.adminRoles, PERMISOS.adminPermisos, PERMISOS.adminAreas,
  PERMISOS.adminFlujosAutorizacion, PERMISOS.adminProveedores, PERMISOS.adminCatalogosContables,
  PERMISOS.adminCatalogosSat, PERMISOS.adminEquivalenciasUnidad, PERMISOS.adminIndicadoresImpuesto,
  PERMISOS.adminMapeosClaveCuenta, PERMISOS.adminTiposDocumento, PERMISOS.adminCategoriasDocumento,
  PERMISOS.adminConfiguraciones, PERMISOS.adminComprasSap, PERMISOS.adminSatMock,
  PERMISOS.adminSolicitudesCatalogo, PERMISOS.adminPlazo, PERMISOS.reporteriaAdministrar,
  PERMISOS.auditoriaVer,
];
